// wrapper over an async method to enforce error-handling
export const to = (promise) => (promise ? (promise
  .then((data) => (
    Array.isArray(data)
    && data.length > 0 ? [data[0], data[1]] : [null, data]
  ))
  .catch((err) => [err])) : [null, null])
